import React from 'react'
import { DesignProvider } from 'contexts/DesignContext'
import { RequireConfigBarHostProvider } from 'components/RequireConfig'
import Form from './Form'
import DesignerRequireConfigProvider, {
  DesignerRequireConfigBar,
} from './RequireConfigProvider'

const Index = (props) => {
  return (
    <React.Fragment>
      <DesignProvider>
        <RequireConfigBarHostProvider>
          <DesignerRequireConfigProvider>
            <Form {...props} />
            <DesignerRequireConfigBar />
          </DesignerRequireConfigProvider>
        </RequireConfigBarHostProvider>
      </DesignProvider>
    </React.Fragment>
  )
}

export default Index
